import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  CleanCustomsDeliveryMethod,
  CleanCustomsDeliveryOrder,
} from '../../../export-types/cleaned-types';
import { IdCell } from '../../common/cards/id-cell-card.component';
import moment from 'moment';
import classNames from 'classnames';
import tableStyle from '../purchase-order/purchase-order-item.module.css';
import { ImagesCell } from '../../common/cards/images-cell-card.component';
import {
  getDeliveryMethodIcon,
  getDeliveryPeriod,
} from '../../../utils/common.utils';

type Props = {
  data: CleanCustomsDeliveryOrder;
};

const TariffCell: React.FC<{ method: CleanCustomsDeliveryMethod }> = ({
  method,
}) => (
  <>
    {method.method === 'sea' ? (
      <i className={'bi bi-water fs-20'} />
    ) : (
      <img src={getDeliveryMethodIcon(method.method)} className="me-3" alt="" />
    )}
    <div>{getDeliveryPeriod(method)}</div>
  </>
);

const ManagerCell = ({ order }: { order: CleanCustomsDeliveryOrder }) =>
  order && <>{order.user?.manager?.name}</>;

export function CustomsDeliveryOrderItem(props: Props) {
  const navigate = useNavigate();

  const href = `/customs-deliveries/order/${props.data.id}`;

  const handleClick = useCallback(() => {
    navigate(href);
  }, [navigate, href]);

  return (
    <div
      className={classNames(
        'row cursor-pointer g-0 position-relative',
        tableStyle.tableRow,
      )}
      onClick={handleClick}
    >
      <div className="col">Логистика ВЭД</div>

      <div className="col">
        <Link
          to={`/customs-deliveries/order/${props.data.id}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <IdCell internalId={props.data.internalId} type={'customs'} />
        </Link>
      </div>
      <div className=" col">{props.data.user?.internalId}</div>
      <div className="col-1">
        <ImagesCell imagesList={props.data.files} />
      </div>
      <div className="col text-truncate h-100">{props.data.name}</div>
      <div className={'col-1'}>
        {' '}
        {props.data.priceData?.customsDeliveryMethod && (
          <TariffCell method={props.data.priceData?.customsDeliveryMethod} />
        )}
      </div>
      <div className={'col-1'}>
        <ManagerCell order={props.data} />
      </div>

      <div className="col">
        <div>{moment(props.data.createdAt).format('DD.MM.YYYY')}</div>
        <div>Создана</div>
      </div>
    </div>
  );
}
